module.exports = __webpack_public_path__ + "static/p2-924d20d8325afc2d06afa3bd7c084105.png";